import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a POST/PUT/PATCH/DELETE that must never take the offline path in `HttpUPSInterceptor` (WI 37077):
 * no queueing for replay and no fake 200 echoing the request body. A network failure then reaches the caller
 * as an error. Use it for a read that has to be a POST to keep data out of the URL (an SSN lookup), whose
 * caller would read an echoed body as a real answer and whose body must not sit in the offline queue.
 */
export const SKIP_OFFLINE_QUEUE = new HttpContextToken<boolean>(() => false);
